<template>
  <div id="app">
    <router-view></router-view>
    <!-- <p style="text-align:center; font-size:12px">
      Copyright ©2020 备案号：
      <a
        href="http://www.beian.miit.gov.cn"
        target="_blank"
        rel="nofollow"
        style="color: #939393;text-decoration: none"
      >粤ICP 14019638 号</a>
    </p> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
html,
body {
  margin: 0;
  min-height: 100%;
  background: rgba(249, 249, 249, 1);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ellipsis-num (@num: 2) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: @num;
  overflow: hidden;
}

.ellipsis-2 {
  .ellipsis-num
}

.ellipsis-3 {
  .ellipsis-num(3)
}
</style>
